import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { PERSIST_KEYS } from '@app/app/persist/persist-keys';

import { UseCase } from '../analytics/types';

type Store = {
  useCase: UseCase;
};

type Actions = {
  setUseCase: (newUseCase: UseCase) => void;
};

const defaultState: Store = {
  useCase: 'skip',
};

export const usePersistedUseCaseStore = create<Store & Actions>()(
  persist(
    (set) => ({
      ...defaultState,
      setUseCase: (newUseCase) => set((state) => ({ ...state, useCase: newUseCase })),
    }),
    {
      name: PERSIST_KEYS.USE_CASE,
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
